import { theme } from '@zendesk/forethought-elements';

export const insightGradients = {
  10: 'linear-gradient(90deg,rgba(255, 179, 147, 0.10) 0%,rgba(171, 213, 250, 0.10) 50%,rgba(18, 167, 180, 0.10) 100%)',
  100: 'linear-gradient(90deg, #ffb393 0%, #abd5fa 50%, #12a6b4 100%)',
  15: 'linear-gradient(90deg,rgba(255, 179, 147, 0.15) 0%,rgba(171, 213, 250, 0.15) 50%,rgba(18, 167, 180, 0.15) 100%)',
  25: 'linear-gradient(90deg,rgba(255, 179, 147, 0.25) 0%,rgba(171, 213, 250, 0.25) 50%,rgba(18, 167, 180, 0.25) 100%)',
};

export const confirmationGradients = {
  100: 'linear-gradient(90deg, #01567A 0%, #2F7492 100%)',
};

export const recommendationGradients = {
  100: 'linear-gradient(135deg, #01567A 0%, #6DBBD7 100%)',
  15: 'linear-gradient(135deg, rgba(255, 179, 147, 0.15) 0%, rgba(171, 213, 250, 0.15) 50%, rgba(18, 166, 180, 0.15) 100%)',
};

export const AB_TEST_GRADIENT =
  'linear-gradient(90deg, rgba(255, 179, 147, 0.5) 0%, rgba(171, 213, 250, 0.5) 50%, rgba(18, 166, 180, 0.5) 100%)';

// Hue-shifted siblings of insightGradients, so the trial banner escalates from
// brand to warning to danger while staying visibly one system. Pending exact
// tokens from forethought-elements.
//
// Like insightGradients these are low-alpha tints meant to sit on white, so the
// banner pairs them with an explicit white backing rather than inheriting the
// page — the agent-builder routes run a dark canvas that would otherwise show
// through and swallow both the tint and the dark text on top of it.
export const TRIAL_EXPIRING_GRADIENT =
  'linear-gradient(90deg, rgba(255, 179, 147, 0.32) 0%, rgba(252, 211, 77, 0.22) 50%, rgba(245, 158, 11, 0.18) 100%)';

export const TRIAL_ENDED_GRADIENT =
  'linear-gradient(90deg, rgba(255, 179, 147, 0.24) 0%, rgba(248, 113, 113, 0.18) 50%, rgba(239, 68, 68, 0.16) 100%)';

// Repeating the colors in case we need more than the alotted metrics
export const GRAPH_CHART_COLORS = Array(5).fill(theme.palette.chart).flat();

// Workflow/agent iconography accent. Not a forethought-elements token yet —
// the autoflow editor's workflow nodes hardcode the same literal
// (autoflow-v2-editor/utils/styleUtils.ts).
export const WORKFLOW_ICON_COLOR = '#B920C7';
